import { render, staticRenderFns } from "./CustomerUpload.vue?vue&type=template&id=10b4631d&scoped=true&"
import script from "./CustomerUpload.vue?vue&type=script&lang=js&"
export * from "./CustomerUpload.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUpload.vue?vue&type=style&index=0&id=10b4631d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4631d",
  null
  
)

export default component.exports